import { PlaceholderShimmerBackground } from 'utils/fragments';
import styled from 'styled-components';

const Placeholder = styled.span`
    background: ${({ theme }) => theme.gray_5};
    ${PlaceholderShimmerBackground}
    min-width: ${({ width }) => width};
    min-height: ${({ height }) => height};
    display: inline-block;
`;

function PlaceholderText({ lines, width = '5rem', height = '1em', ...props }) {
    return !lines ? (
        <Placeholder width={width} height={height} {...props} />
    ) : (
        <p css="line-height: 24px;">
            {new Array(lines).fill('').map((unused, idx) => (
                <Placeholder
                    width={idx === lines - 1 ? '40%' : '100%'}
                    height={height}
                    key={`shimmergraph-line-${idx}`}
                    {...props}
                />
            ))}
        </p>
    );
}

export default PlaceholderText;
